module.exports = __webpack_public_path__ + "static/modesta-bc-06-48350a41415d4e90b910fb224baaae88.png";